import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page-container w-full grid place-items-center min-h-full" }
const _hoisted_2 = { class: "container flex justify-center items-center" }

import LoginForm from '@/components/v2/Forms/LoginForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginForm)
    ])
  ]))
}
}

})